module.exports = __webpack_public_path__ + "static/media/hfil_logo.44620be9.png";